module.exports.config = {
  "declarative": true,

  "render-module": {
    "name": "PieceCardHoverRenderModule",
    "path": "front/piece-card-hover-render.module"
  },

  "definition": {
    "name": "PieceCardHoverDefinition",
    "group": "Basic",
    "availablePlatforms": ["web"],
    "description": "Card Hover UP",

    "fields": [
      {
        "name": "link",
        "label": "Url de destino",
        "type": "link",
        "mandatory": true
      },
      {
        "type": "groupCollapsable",
        "name": "image",
        "label": "Imágenes",
        "fields": [
          {
            "label": "Landscape",
            "name": "imgLandscape",
            "type": "image",
            "mandatory": true,
            "defaultValue": ""
          },
          {
            "label": "Portrait",
            "name": "imgPortrait",
            "type": "image",
            "mandatory": true,
            "defaultValue": ""
          },
        ]
      },
      {
        "type": "groupCollapsable",
        "name": "title",
        "label": "Título",
        "flattenFields": true,
        "fields": [
          {
            "name": "titleText",
            "type": "richText",
            "mandatory": true,
            "defaultValue": ""
          },
          {
            "label": "Padding",
            "name": "titlePadding",
            "jsonPath": "styles.padding",
            "type": "linkedUnits"
          }
        ]
      },
      {
        "type": "groupCollapsable",
        "name": "subtitle",
        "label": "Subtitulo",
        "flattenFields": true,
        "fields": [
          {
            "name": "subtitleText",
            "type": "richText",
            "mandatory": false,
            "defaultValue": ""
          },
          {
            "label": "Padding",
            "name": "subtitlePadding",
            "jsonPath": "styles.padding",
            "type": "linkedUnits"
          }
        ]
      },
      {
        "type": "groupCollapsable",
        "name": "button",
        "label": "Boton",
        "flattenFields": true,
        "fields": [
          {
            "label": "Texto del botón",
            "name": "buttonText",
            "type": "richText",
            "mandatory": false,
            "defaultValue": ""
          },
          {
            "label": "Padding",
            "name": "buttonPadding",
            "jsonPath": "styles.padding",
            "type": "linkedUnits"
          },
          {
            "label": "texto color hover",
            "name": "colorTxtHover",
            "type": "color",
            "mandatory": false,
            "defaultValue": "#fff"
          },
          {
            "label": "Color del fondo del boton",
            "name": "bgColorBtn",
            "type": "color",
            "mandatory": false,
            "defaultValue": "#000"
          },
          {
            "label": "Color del fondo del boton hover",
            "name": "bgColorBtnHover",
            "type": "color",
            "mandatory": false,
            "defaultValue": "#fff"
          },
        ]
      },
      {
        "type": "groupToggleable",
        "name": "alignment",
        "label": "Alinear",
        "section": "styles",
        "jsonPath": "alignment",
        "fields": [
          {
            "name": "vertical",
            "label": "Posición vertical",
            "type": "options",
            "jsonPath": "alignVertical",
            "values": [
              {
                "value": "top",
                "label": "Arriba"
              },
              {
                "value": "center",
                "label": "Centro"
              },
              {
                "value": "bottom",
                "label": "Abajo"
              }
            ],
            "defaultValue": "center"
          },
          {
            "name": "horizontal",
            "label": "Posición horizontal",
            "type": "options",
            "jsonPath": "alignHorizontal",
            "values": [
              {
                "value": "left",
                "label": "Izquierda"
              },
              {
                "value": "middle",
                "label": "Medio"
              },
              {
                "value": "right",
                "label": "Derecha"
              }
            ],
            "defaultValue": "middle"
          }
        ]
      }
    ]
  }
};
